export default function buildAssetPath(path: string): string {
  if (typeof window !== 'undefined') return `${process.env.ASSETS_URL}/${path}`;
}
